export const checkLocation = (
  data?: {
    onSuccess?: (data: GeolocationPosition) => void;
  }
) => {
  if (!navigator.geolocation) {
    window.alert("Cannot access location api");
    return;
  }
  navigator.geolocation.getCurrentPosition(
    (d) => data?.onSuccess?.(d),
    (e) => {
      window.confirm(e.message);
      document.location.reload();
    }
  );
};
